import './main.css';
import { ShowIf } from './Security/security';
import { Navigate } from 'react-router-dom';
import Dashboard from './Dashboard/Dashboard';
import ListUnifiedEpoLoads from './ListUnifiedEpoLoads';
import { useSecurity } from './Security/security';

const Main = () => {
  const { validateRole } = useSecurity();

  if (validateRole({ department: 'FIN' })) {
    // redirect FINANCE users to reports screen
    return <Navigate to="/ReportsList" replace />;
  }

  return (
    <ShowIf
      or={[
        { department: 'TRADER' },
        { department: 'LSP' },
        { department: 'WLP' },
        { department: 'OPS' },
        { department: 'QA' },
      ]}
    >
      <section>
        <ShowIf or={[{ department: 'OPS' }, { department: 'QA' }]}>
          <div className="px-4 pb-5 pt-2 d-flex flex-column align-items-end">
            <Dashboard />
          </div>
        </ShowIf>

        <ShowIf or={[{ department: 'TRADER' }, { department: 'LSP' }, { department: 'WLP' }, { department: 'FIN' }]}>
          <ListUnifiedEpoLoads />
        </ShowIf>
      </section>
    </ShowIf>
  );
};

export default Main;
